import { AuthConfig } from 'angular-oauth2-oidc';

export function createAuthConfig(oidcEnv: any): AuthConfig {
  return {
    issuer: oidcEnv.issuer,
    redirectUri: oidcEnv.redirectUri,
    clientId: oidcEnv.clientId,
    responseType: 'code',
    scope: oidcEnv.scope,
    loginUrl: oidcEnv.authorizationEndpoint,
    tokenEndpoint: oidcEnv.tokenEndpoint,
    logoutUrl: oidcEnv.logoutEndpoint,
    postLogoutRedirectUri: oidcEnv.postLogoutRedirectUri,
    requireHttps: oidcEnv.requireHttps ?? true,
    skipIssuerCheck: true,
    strictDiscoveryDocumentValidation: false,
    showDebugInformation: !oidcEnv.production,
    useSilentRefresh: false,
  };
}
